<template>
  <div class="budgetDialog">
    <el-dialog
      title="定时改预算"
      :visible.sync="dialogVisible"
      :destroy-on-close="true"
      width="30%"
    >
      <el-form
        ref="form"
        :model="formData"
        label-width="80px"
        :rules="rules"
      >
        <el-form-item
          label="日期"
          prop="dateVal"
        >
          <el-date-picker
            v-model="formData.dateVal"
            type="datetime"
            placeholder="选择日期"
            format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="pickerOptions"
            popper-class="overlay-datetime-picker"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="类型">
          <el-input
            :value="budgetType"
            readonly
          ></el-input>
        </el-form-item>
        <el-form-item
          label="预算金额"
          prop="budgetAmount"
        >
          <el-input
            v-model="formData.budgetAmount"
            @input="(val) => handleInput(val, formData, 'budgetAmount')"
          ></el-input>
        </el-form-item>
      </el-form>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="submit"
          :loading="loading"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import moment from 'moment';
import { settingAdScheduleUpdateBudgetTask } from '../../serve/setTimes';
export default {
  props: {
    platform: {
      type: String,
      default: 'facebook',
    },
    gimpUserId: {
      type: [String, Number],
      default: '',
    },
    thirdUserId: {
      type: String,
      default: '',
    },
    clientType: {
      type: String,
      default: 'pc',
    },
    level: {
      type: String,
      default: 'campaign',
    },
    row: {
      type: Object,
      default: () => ({}),
    },
    objectiveEnum: {
      type: String,
      default: null,
    },
    subType: {
      type: String,
      default: null,
    },
    isSmartPlusCampaign: {
      type: Boolean,
      default: false,
    },
    needDec100: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const validateBudgetAmount = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入预算金额'));
        return;
      }

      // Snapchat 平台特殊校验：范围 [5, 10000000)
      if (this.platform === 'snapchat') {
        const numValue = Number(value);
        if (numValue < 5) {
          callback(new Error('请输入5 - 10000之间的数字'));
          return;
        }
        if (numValue >= 10000) {
          callback(new Error('请输入5 - 10000之间的数字'));
          return;
        }
      }
      // Google 平台特殊校验：范围 [0.01, 10000000)
      if (this.platform === 'google') {
        const numValue = Number(value);
        if (numValue < 0.01) {
          callback(new Error('请输入0.01 - 1000000之间的数字'));
          return;
        }
        if (numValue >= 10000) {
          callback(new Error('请输入0.01 - 1000000之间的数字'));
          return;
        }
      }

      callback();
    };

    return {
      dialogVisible: false,
      formData: {
        dateVal: '',
        budgetAmount: '',
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      loading: false,
      rules: {
        dateVal: { required: true, message: '请选择日期', trigger: 'blur' },
        budgetAmount: {
          required: true,
          validator: validateBudgetAmount,
          trigger: 'blur',
        },
      },
    };
  },
  computed: {
    ...mapState('user', ['userInfo']),
    budgetType() {
      return this.row.daily_budget ||
        (this.row.ad && this.row.ad.campaignDailyBudget) ||
        (this.row.ad && this.row.ad.adGroupDailyBudget) ||
        (this.row && this.row.budget_type === 'DAILY')
        ? '日预算'
        : '总预算';
    },
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.show();
      }
    },
  },
  methods: {
    show() {
      // 检查是否有定时预算配置
      if (this.row.open_schedule) {
        const budget = this.row.open_schedule.find((item) => item.type == 2);
        if (budget) {
          this.formData.budgetAmount =
            budget.dailyBudget || budget.lifetimeBudget || budget.budgetAmount || budget.budget;
          this.formData.dateVal = budget.timeStr;
          return;
        }
      }

      // 设置默认预算金额
      if (this.row.daily_budget) {
        if (this.needDec100) {
          this.formData.budgetAmount = (this.row.daily_budget / 100).toFixed(2);
        } else {
          this.formData.budgetAmount = this.row.daily_budget;
        }
      } else if (this.row.lifetime_budget) {
        if (this.needDec100) {
          this.formData.budgetAmount = (this.row.lifetime_budget / 100).toFixed(2);
        } else {
          this.formData.budgetAmount = this.row.lifetime_budget;
        }
        // 兼容google
      } else if (this.row.budget_type === 'DAILY' || this.row.budget_type === 'LIFE_TIME') {
        this.formData.budgetAmount = this.row.budget_amount;
      }
      this.formData.dateVal = moment().add(1, 'day').startOf('day').format('YYYY-MM-DD HH:mm:ss');
    },
    hide() {
      this.dialogVisible = false;
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let request = {
            gimpUserId: this.gimpUserId || this.userInfo.data.id, // 单点id
            platform: this.platform, // 平台
            thirdUserId: this.row.rowThirdNum || this.$store.state.num.selectedNum, // 个号id
            adAccountId: this.row.adAccountId || this.$store.getters.accountId, // 账号id
            level: this.level, // 层级
            campaignId: this.row.campaignId, // 系列id
            adGroupId: this.row.adGroupId, // 广告组id
            id: this.row.id, //当前层级ID
            handleTime: this.formData.dateVal, // 定时时间
            clientType: this.clientType, // 来源：pc还是手机端,不用传，写死2
          };

          // 仅当平台为tiktok时才添加这三个参数
          if (this.platform === 'tiktok') {
            request.objectiveEnum = this.objectiveEnum;
            request.subType = this.subType;
            request.isSmartPlusCampaign = this.isSmartPlusCampaign;
          }
          if (
            this.row.daily_budget ||
            (this.row.ad && this.row.ad.campaignDailyBudget) ||
            (this.row.ad && this.row.ad.adGroupDailyBudget) ||
            this.row.budget_type === 'DAILY'
          ) {
            request.dailyBudget = this.formData.budgetAmount;
            request.lifetimeBudget = null;
          } else {
            request.dailyBudget = null;
            request.lifetimeBudget = this.formData.budgetAmount;
          }

          this.loading = true;
          settingAdScheduleUpdateBudgetTask(JSON.stringify(request))
            .then((res) => {
              this.loading = false;
              this.hide();
              if (res.code === 0) {
                this.$message.success('定时修改预算已打开！');

                this.$emit(
                  'settingComplete',
                  this.formData,
                  2,
                  this.row.id,
                  this.formData.budgetAmount,
                  res.data.id,
                  res.data,
                );
              }
            })
            .catch(() => {
              this.loading = false;
              this.hide();
            });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleInput(value, arrName, keyName) {
      this.$set(
        arrName,
        keyName,
        value
          .replace(/[^\d.]/g, '')
          .replace(/^\./g, '')
          .replace(/\.{2,}/g, '.')
          .replace('.', '$#$')
          .replace(/\./g, '')
          .replace('$#$', '.')
          .replace(/^(-)*(\d+)\.(\d\d).*$/, '$1$2.$3'),
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.el-table td.el-table__cell div.el-dialog__header {
  text-align: left;
}
.budgetDialog {
  .el-input,
  .el-select {
    width: 100%;
  }
  .el-form-item {
    margin-bottom: 23px !important;
  }
}
</style>
